<div class="w-full p-3 h-full relative assets-container">
  <div class="head-container mb-1">
    <mat-form-field appearance="outline" class="input-field">
      <mat-label>Search...</mat-label>
      <input matInput [formControl]="searchFormControl" #input />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="w-full">
      <ng-container matColumnDef="Trailer Number">
        <th mat-header-cell *matHeaderCellDef>Trailer Number</th>
        <td mat-cell *matCellDef="let element" class="text-blue-500">
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element | lamAssetStatus }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Owner">
        <th mat-header-cell *matHeaderCellDef>Owned</th>
        <td mat-cell *matCellDef="let element">
          {{ element.companyName | dashIfNothing }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <ng-container *ngIf="searchFormControl.value.length > 0">
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="6">No data matching "{{ input.value }}"</td>
        </tr>
      </ng-container>
    </table>
  </div>
</div>
